import { formatDate } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DateTimeService {
  constructor() {}

  getCurrentDate(): Date {
    return new Date();
  }

  convertDateToString(date: Date | undefined): string | undefined {
    if (date == null) {
      return undefined;
    }
    try {
      return formatDate(date, 'yyyy-MM-dd', 'en-US');
    } catch {
      return undefined;
    }
  }

  convertDateTimeToString(date: Date | undefined): string | undefined {
    if (date == null) {
      return undefined;
    }
    try {
      return formatDate(date, 'yyyy-MM-ddTHH:mm:ss', 'en-US');
    } catch {
      return undefined;
    }
  }

  convertStringToDate(date: string | undefined): Date | null {
    if (date == null) {
      return null;
    }
    return new Date(date);
  }

  // Converts date object to string. This avoids timezone confusion in backend/database
  formatDateToString(date: Date | null): string | null {
    if (!date) return null;
    const yyyy = date.getFullYear();
    const mm = (date.getMonth() + 1).toString().padStart(2, '0');
    const dd = date.getDate().toString().padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }
}
